import React from "react";

import { useFeatureFlag } from "fond/featureFlags";

import { NavigationNew } from "./NavigationNew";
import NavigationOld from "./NavigationOld";

const ProjectsNavigation: React.FC = () => {
  const { value: isFondGlowUpEnabled } = useFeatureFlag("fond_glow_up");
  if (isFondGlowUpEnabled) {
    return <NavigationNew />;
  }
  return <NavigationOld />;
};

export default React.memo(ProjectsNavigation);
